module.exports = __webpack_public_path__ + "src/assets/games/9/197.jpg";